<!-- 集控器编辑框 -->
<template>
    <el-dialog :title="title" :visible.sync="visible" :before-close="handleCloseDialog">
        <el-form :model="deviceForm" :rules="rules" ref="deviceForm" label-width="100px">
            <el-row :gutter="5">
                <el-col :span="12">
                    <el-form-item label="变量名称" prop="var_name">
                        <el-input v-model="deviceForm.var_name"></el-input>
                    </el-form-item>
                    <el-form-item label="操作码" prop="opcode" >
                        <el-select v-model="deviceForm.opcode" clearable placeholder="请选择" @change="cofingaddrlist">
                            <el-option label="01" :value="1" :disabled="deviceForm.var_type ==1?true:false"></el-option>
                            <el-option label="03" :value="3" :disabled="deviceForm.var_type ==2?true:false"></el-option>
                            <el-option label="05" :value="5" :disabled="deviceForm.var_type ==1?true:false"></el-option>
                            <el-option label="06" :value="6" :disabled="deviceForm.var_type ==2?true:false"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="变量地址" prop="var_Initial_addr" >
                        <el-row :gutter="5" style="margin:0;">
                            <el-col :span="12">
                                <el-input v-model.number="deviceForm.var_Initial_addr"></el-input>
                            </el-col>
<!--                            <el-col :span="12">
                                <el-select v-model="deviceForm.bytes" placeholder="字节类型">
                                    <el-option label="单字节" :value="1"></el-option>
                                    <el-option label="双字节float" :value="2"></el-option>
                                    <el-option label="双字节Int" :value="3"></el-option>
                                </el-select>
                            </el-col> -->
                        </el-row>
                    </el-form-item>
<!--                    <el-form-item label="地址类型" prop="var_type">
                        <el-select v-model="deviceForm.var_type" placeholder="请选择">
                            <el-option label="int" :value="1"></el-option>
                            <el-option label="bool" :value="2"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="地址类型" prop="var_type" >
                        <el-select v-model="value" clearable  placeholder="请选择" value-key="id" @change="cofingbytes">
<!--                            <el-option label="位" :value="2"></el-option>
                            <el-option label="16位有符号" :value="1"></el-option>
							<el-option label="32位有符号" :value="3"></el-option>
							<el-option label="单精度浮点" :value="4"></el-option> -->
								<el-option
							        v-for="item in addrtypelist"
							        :key="item.id"
							        :label="item.label"
							        :value="item"
									:disabled="item.disabled">
							    </el-option>  
                        </el-select>
                    </el-form-item>
                    <el-form-item label="变量取值" v-if="deviceForm.var_type === 2">
                        <el-row :gutter="5" style="margin:0;">
                            <el-col :span="12">
                                <el-input v-model="deviceForm.var_0_represent" placeholder="为0状态"></el-input>
                            </el-col>
                            <el-col :span="12">
                                <el-input v-model="deviceForm.var_1_represent" placeholder="为1状态"></el-input>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <!-- <el-form-item label="单位符号" prop="var_description">
                        <el-input v-model="deviceForm.unit"></el-inpu h    Bar   HZ   kWh   KWt>
                    </el-form-item> -->
					<el-form-item label="单位符号" prop="var_description">
					    <el-select v-model="deviceForm.unit" clearable placeholder="请选择" >
					        <el-option label="℃" value='℃'></el-option>
					        <el-option label="h" value="h"></el-option>
					        <el-option label="Bar" value="Bar"></el-option>
					        <el-option label="HZ" value="HZ"></el-option>
							<el-option label="kWh" value="kWh"></el-option>
							<el-option label="KW" value="KW"></el-option>
					    </el-select>
					</el-form-item>
                    <el-form-item label="线性换算" prop="var_description" v-if="deviceForm.var_type != 2">
                        <el-checkbox v-model="deviceForm.linear_conversion" @change="changdisabledstatu">线性换算</el-checkbox>
                    </el-form-item>
					<el-form-item label="高低位互换" prop="is_swap" >
					    <el-checkbox v-model="deviceForm.is_swap" @change="changdisswap">高低位互换</el-checkbox>
					</el-form-item>
                    <el-form-item label="变量描述" prop="var_description">
                        <el-input v-model="deviceForm.var_description"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="输入最小值" prop="input_min">
                        <el-input v-model="deviceForm.input_min" :disabled="disabledstatu" v-on:change="changenum"></el-input>
                    </el-form-item>
                    <el-form-item label="输入最大值" prop="input_max">
                        <el-input v-model="deviceForm.input_max" :disabled="disabledstatu" v-on:change="changenum"></el-input>
                    </el-form-item>
                    <el-form-item label="工程最小值" prop="output_min">
                        <el-input v-model="deviceForm.output_min" :disabled="disabledstatu"></el-input>
                    </el-form-item>
                    <el-form-item label="工程最大值" prop="output_max">
                        <el-input v-model="deviceForm.output_max" :disabled="disabledstatu"></el-input>
                    </el-form-item>
                    <el-form-item label="倍数" prop="var_unit">
                        <el-input v-model="deviceForm.var_unit" ></el-input>
                    </el-form-item>
                    <el-form-item label="有效小数位" prop="display_format">
                        <el-select v-model="deviceForm.display_format" placeholder="请选择活动区域">
                            <el-option label="0" :value="0"></el-option>
                            <el-option label="1(例：0.1)" :value="1"></el-option>
                            <el-option label="2(例：0.01)" :value="2"></el-option>
                            <el-option label="3(例：0.001)" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设置范围">
                         <el-col :span="11">
                            <el-form-item prop="range_min">
                                <el-input v-model="deviceForm.range_min" placeholder="最小值"></el-input>
                            </el-form-item>
                            </el-col>
                            <el-col class="line" :span="2">-</el-col>
                            <el-col :span="11">
                            <el-form-item prop="range_max">
                                <el-input v-model="deviceForm.range_max" placeholder="最大值"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">取 消</el-button>
            <el-button type="primary" @click="submitForm('deviceForm')">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Service from '@/api/Service'

const Params = { 
    plc_type_id: '',
    var_name: '',
    opcode: '',
    var_Initial_addr: '',
    bytes:0,
    var_addr_ranges: '',
    var_type: '',
    var_description: '',
    input_min: '',
    input_max: '',
    output_min: '',
    output_max: '',
    var_unit: '',
    var_0_represent: '',
    var_1_represent: '',
    range_min: '',
    range_max: '',
    display_format: '',
    unit: '',
    linear_conversion: false,
	is_swap:false,
}

export default {
    name: 'cmpOptFormDialog',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        form: {
            type: Object,
            default: {}
        }
    },
    data () {
        return {
			title:'',
            dialogFormVisible: false,
            deviceForm: JSON.parse(JSON.stringify(Params)),
			//表单验证
            rules: {
				var_name:[
					{ required: true, message: '请输入变量名称', trigger: 'blur' }
				],
				opcode:[
					{required: true, message: '请选择操作码', trigger: 'change' }
				],
				var_Initial_addr:[
					{ required: true, message: '请输入变量地址'},
					{ type: 'number', message: '变量地址必须为整数'}
				],
				var_type:[
					{ required: true, message: '请选择地址类型', trigger: 'change' }
				],
			},
			value:'',
			disabledstatu:true,
			opcodestatu:false,
			addrtypelist:[
				{
					id:0,
					label:"位",
					bytes:1,
					var_type:2,
					disabled:false
				},
				{
					id:1,
					label:"16位有符号",
					bytes:1,
					var_type:1,
					disabled:false
				},
				{
					id:2,
					label:"32位有符号",
					bytes:2,
					var_type:3,
					disabled:false
				},
				{
					id:3,
					label:"单精度浮点",
					bytes:2,
					var_type:4,
					disabled:false
				},
				{
					id:4,
					label:"16位无符号",
					bytes:1,
					var_type:5,
					disabled:false
				},
				{
					id:5,
					label:"32位无符号",
					bytes:2,
					var_type:6,
					disabled:false
				},
			]
        };
    },

    watch: {
        visible(newVal) {
            if(newVal) {
                this.handleInitData(this.form);
            }
        }
    },
	// created() {
	// 	console.log(this.deviceForm)
	// },
 //    computed: {
 //        title() {
 //            return this.deviceForm.OID ? "修改" : "新增";
 //        }
 //    },

    methods: {
		// changc(v){
		// 	if(v == 1){
		// 		this.deviceForm.unit ="℃"
		// 	}
		// },
		//设置右边模块是否可以编辑
		
		//监听最大最小值
		changenum(){
			if(this.deviceForm.input_min != '' && this.deviceForm.input_max != ''){
				if(this.deviceForm.input_min >= this.deviceForm.input_max){
					this.$message({
						type: 'warning',
						message: '最大值需要比最小值大！！!',
					});
					return
				}
			}
			
		},
		changdisabledstatu(v){
			this.disabledstatu = !v
		},
		changdisswap(){
			this.is_swap = true
		},
		//动态设置addr的可选项
		cofingaddrlist(){
			var v=this.deviceForm.opcode
			if(v == 1 || v == 5){
				this.addrtypelist[0].disabled=false
				this.addrtypelist[1].disabled=true
				this.addrtypelist[2].disabled=true
				this.addrtypelist[3].disabled=true
				this.addrtypelist[4].disabled=true
				this.addrtypelist[5].disabled=true
				this.disabledstatu=true
			}else if(v == 3 || v == 6){
				this.addrtypelist[0].disabled=true
				this.addrtypelist[1].disabled=false
				this.addrtypelist[2].disabled=false
				this.addrtypelist[3].disabled=false
				this.addrtypelist[4].disabled=false
				this.addrtypelist[5].disabled=false
			}
		},
		//设置bytes
		cofingbytes(v){
			this.deviceForm.var_type = v.var_type
			this.deviceForm.bytes = v.bytes
			this.deviceForm
		},
        handleInitData(Val) {
            if(JSON.stringify(Val) === "{}") return;
            if(Val.oid) {
                // 编辑
				this.title = "编辑"
                this.deviceForm = Object.assign({}, Val);
				
				if(this.deviceForm.var_type == 1){
					this.value = '16位有符号';
					this.cofingaddrlist(1)
				}else if(this.deviceForm.var_type == 2){
					this.value = '位'
					this.addrtypelist[0].disabled=true
				}else if(this.deviceForm.var_type == 3){
					this.value = '32位有符号'
					this.addrtypelist[0].disabled=true
				}else if(this.deviceForm.var_type == 4){
					this.value = '单精度浮点'
					this.addrtypelist[0].disabled=true
				}else if(this.deviceForm.var_type == 5){
					this.value = '16位无符号'
					this.addrtypelist[0].disabled=true
				}else{
					this.value = '32位无符号'
					this.addrtypelist[0].disabled=true
				}
            }else{
                // 新增
				this.title = "新增"
                this.deviceForm = Object.assign({ terminal_id: Val.terminal_id }, Params)
				this.value=''
            }
        },
        // 关闭弹框
        handleCloseDialog() {
            this.$emit("handleCloseDialog", {flag: false});
			this.value=""
			for(var i=0;i<this.addrtypelist.length;i++){
				this.addrtypelist[i].disabled=false
			}
			this.disabledstatu=true
			// window.location.reload()
        },
		//表单验证
		submitForm(formName) {
			if(this.deviceForm.input_min != '' && this.deviceForm.input_max != ''){
				if(this.deviceForm.input_min >= this.deviceForm.input_max){
					this.$message({
						type: 'warning',
						message: '最大值需要比最小值大！！!',
					});
					this.deviceForm.input_min = ''
					this.deviceForm.input_max = ''
					return
				}
			}		
			this.$refs[formName].validate((valid) => {
			if (valid) {
				this.handleSave()
				} else {
				return false;
				}
			});
			
		},
        // 确认关闭
        async handleSave() {
            let res
            if(this.deviceForm.oid) {
                // 修改
                res = await Service.editPlcConfiguration(this.deviceForm)
            }else {
                // 新增
                 res = await Service.addPlcConfiguration(this.deviceForm)
            }
            if(res) {
                 this.$message({
                    type: 'success',
                    message: '操作成功!',
                });
            }
            this.$emit("handleCloseDialog", {flag: true, data: {}});
        },
    }
}

</script>
<style lang='less' scoped>
</style>